/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ matched: NonNullable<unknown>, ambiguous: NonNullable<unknown>, unmatched: NonNullable<unknown> }} Jobs_Result_Portal_MappingInputs */

const cs_jobs_result_portal_mapping = /** @type {(inputs: Jobs_Result_Portal_MappingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`✓${i?.matched} spárováno · ?${i?.ambiguous} nejisté · ✕${i?.unmatched} nespárováno`)
};

const en_jobs_result_portal_mapping = /** @type {(inputs: Jobs_Result_Portal_MappingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`✓${i?.matched} matched · ?${i?.ambiguous} unsure · ✕${i?.unmatched} unmatched`)
};

/**
* | output |
* | --- |
* | "✓{matched} matched · ?{ambiguous} unsure · ✕{unmatched} unmatched" |
*
* @param {Jobs_Result_Portal_MappingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const jobs_result_portal_mapping = /** @type {((inputs: Jobs_Result_Portal_MappingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Result_Portal_MappingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_result_portal_mapping(inputs)
	return cs_jobs_result_portal_mapping(inputs)
});